<template>
  <div class="bespread-wrap module-layer3">
    <div class="screen-container">
      <div class="bg" :class="'b-' + activeIndex">
        <div class="title">
          <img
            :src="
              require('../../assets/img/layer3/' +
                      lang + '/role-' +
                activeIndex +
                '/title.png')
            "
          />
        </div>
      </div>
      <div class="layer-line-cnt">
        <div class="cnt">
          <div class="left-role-icon">
            <div v-for="(item, Iidx) in roleIconList" :key="Iidx">
              <div v-if="activeIndex == item.id" class="icon-item">
                <div
                  v-for="(iconItem, idx) in item.list"
                  :key="idx"
                  class="icon-s"
                  :class="iconActive == iconItem.id ? 'active-icon-bg' : ''"
                >
                  <img :src=" require('../../assets/img/layer3/' +
                      lang +
                      '/role-' +  item.id + '/' + 'icon-' + iconItem.idx + '.png') "
                  @click="handleIcon(iconItem)"
                  @mouseover="showbg(iconItem)" @mouseleave="hideBg(iconItem)"
                  />
                  <div
                    class="img-bg"
                    v-if="bgFlag && bgIdx == iconItem.id"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="left-icon-change"></div>
          <div class="bottom-icon">
            <div
              class="bottom-num "
              :class="['bottom-' + item, 'bottom-shili-' + item]"
              v-for="(item, idx) in list"
              :key="idx"
            >
              <div @click="handleRcSl(item)">
                <img
                  v-if="activeIndex == item"
                  :src="
                    require('../../assets/img/layer3/' +
                      lang +
                      '/b-icon-' +
                      item +
                      '-active.png')
                  "
                  class="activeicon"
                />
                <img
                  v-else
                  :src="
                    require('../../assets/img/layer3/' +
                      lang +
                      '/b-icon-' +
                      item +
                      '.png')
                  "
                  class="icon"
                />
              </div>
            </div>
          </div>
          <!-- model 校色 -->
          <div v-if="roleModel" class="model-role-bg" @click="hideRoleModel">
            <div class="m-role-line"></div>
            <img :src="roleUrl" class="role" />
            <img :src="roleIconUrl" class="role-icon" />
          </div>
        </div>
      </div>
      <div
        class="model  model-z-idx"
        v-if="roleModel"
        @click="hideRoleModel"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      lang: "en",
      list: [1, 2, 3, 4, 5],
      activeIndex: 3,
      iconActive: "r-3-1",
      roleIconList: [
        {
          id: 1,
          list: [
            {
              idx: 1,
              id: "r-1-1",
            },
            {
              idx: 2,
              id: "r-1-2",
            },
            {
              idx: 3,
              id: "r-1-3",
            },
            {
              idx: 4,
              id: "r-1-4",
            },
            {
              idx: 5,
              id: "r-1-5",
            }
          ]
        },
        {
          id: 2,
          list: [
            {
              idx: 1,
              id: "r-2-1",
            },
            {
              idx: 2,
              id: "r-2-2",
            },
            {
              idx: 3,
              id: "r-2-3",
            },
            {
              idx: 4,
              id: "r-2-4",
            }
          ]
        },
        {
          id: 3,
          list: [
            {
              idx: 1,
              id: "r-3-1",
            },
            {
              idx: 2,
              id: "r-3-2",
            },
            {
              idx: 3,
              id: "r-3-3",
            },
            {
              idx: 4,
              id: "r-3-4",
            }
          ]
        },
        {
          id: 4,
          list: [
            {
              idx: 1,
              id: "r-4-1",
            },
            {
              idx: 2,
              id: "r-4-2",
            },
            {
              idx: 3,
              id: "r-4-3",
            },
            {
              idx: 4,
              id: "r-4-4",
            },
            {
              idx: 5,
              id: "r-4-5",
            }
          ]
        },
        {
          id: 5,
          list: [
            {
              idx: 1,
              id: "r-5-1",
            },
            {
              idx: 2,
              id: "r-5-2",
            },
            {
              idx: 3,
              id: "r-5-3",
            },
            {
              idx: 4,
              id: "r-5-4",
            }
          ]
        }
      ],
      roleUrl: "",
      roleIconUrl: "",
      roleModel: false,
      bgFlag: false,
      bgIdx: "0"
    };
  },
  watch: {},
  created() {},
  methods: {
    showbg(item) {
      this.bgFlag = true;
      this.bgIdx = item.id;
      if (this.iconActive == item.id) {
        this.bgFlag = false;
      }
    },
    hideBg(item) {
      this.bgFlag = false;
      this.bgIdx = 0;
    },

    handleIcon(item) {
      this.roleUrl = require("../../assets/img/layer3/role-" +
        this.activeIndex +
        "/" +
        item.id +
        ".png");
      this.roleIconUrl = require("../../assets/img/layer3/"+this.lang+"/role-" +
        this.activeIndex +
        "/" +
        item.id +
        "-icon.png");

      this.roleModel = true;
      this.iconActive = item.id;

      console.log('侠士角色', item)
    },
    hideRoleModel() {
      this.roleModel = false;
      this.roleUrl = "";
      this.roleIconUrl = "";

      this.iconActive = "";
    },
    handleRcSl(val) {
      this.$nextTick(() => {
        if (val == 1) {
          this.list = [4, 5, 1, 2, 3];
        }
        if (val == 2) {
          this.list = [5, 1, 2, 3, 4];
        }
        if (val == 3) {
          this.list = [1, 2, 3, 4, 5];
        }
        if (val == 4) {
          this.list = [2, 3, 4, 5, 1];
        }
        if (val == 5) {
          this.list = [3, 4, 5, 1, 2];
        }
        this.activeIndex = val;
        // this.roleModel = true
        // this.roleUrl = require('../../assets/img/layer3/role-' + (this.activeIndex) + '/r-' + (this.activeIndex) + '-1.png')
      });

      // let txt
      // txt = val
      // if (txt == 1) {
      //   this.handleItem()
      //   this.getSl1()
      //   txt = 4
      // }
      // if (txt == 4) {
      //   this.handleItem()
      //   this.getSl4()
      //   txt = 2
      // }
      // if (txt == 2) {
      //   this.handleItem()
      //   this.getSl2()
      //   txt = 5
      // }
      // if (txt == 5) {
      //   this.handleItem()
      //   this.getSl5()
      //   txt = 3
      // }
      // if (txt == 5) {
      //   this.handleItem()
      //   this.getSl3()
      //   txt = 1
      // }
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer3 {
  .screen-container {
    position: relative;

    .model-z-idx {
      z-index: 0;
      position: absolute;
      background: rgba(0, 0, 0, 0.6);
    }

    .bg {
      width: 100%;
      height: 100%;
      position: relative;
      background-position: center;

      .title {
        width: 602px;
        height: auto;
        position: absolute;
        bottom: 23vw;

        left: 16vw;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }

    .b-1 {
      background-image: url("../../assets/img/layer3/b-1.png");
      background-size: cover;
    }

    .b-2 {
      background-image: url("../../assets/img/layer3/b-2.png");
      background-size: cover;
    }

    .b-3 {
      background-image: url("../../assets/img/layer3/b-3.png");
      background-size: cover;
    }

    .b-4 {
      background-image: url("../../assets/img/layer3/b-4.png");
      background-size: cover;
    }

    .b-5 {
      background-image: url("../../assets/img/layer3/b-5.png");
      background-size: cover;
    }

    .layer-line-cnt {
      width: 100%;
      height: 50vw;
      position: absolute;
      bottom: 0;
      background-image: url("../../assets/img/layer3/left_line.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: left bottom;

      .cnt {
        position: relative;
        width: 100%;
        height: 100%;

        .m-role-line {
          z-index: 1;
          position: absolute;
          right: 22vw;
          top: 50%;
          transform: translate(0, -50%);
          width: 46vw;
          height: 34vw;
          background-image: url("../../assets/img/layer3/model-role.png");
          background-size: 100% 100%;
        }

        .left-icon-change {
          background-image: url("../../assets/img/layer3/left-bg.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center top;
          width: 9vw;
          height: 5vw;
          position: absolute;
          bottom: 15vw;
          left: 3vw;
          z-index: 1;
        }

        .left-role-icon {
          position: absolute;
          bottom: 12vw;
          left: 15vw;

          z-index: 2;

          .icon-item {
            display: flex;
            align-items: center;
            position: relative;
            width: 40vw;
            height: 158px;

            .icon-s {
              width: 152px;
              height: 158px;
              margin-left: -1.7vw;
              cursor: pointer;
              position: relative;

              img {
                width: 100%;
                height: 100%;
                display: block;
                z-index: 1;
                position: relative;
              }

              :hover {
                // background-image: url("../../assets/img/layer3/icon-hover.png");
                // background-size: 100% 100%;
              }
              // img::after {
              //     content: '';
              //     position: absolute;
              //     width: 203px;
              //     height: 212px;
              //     top: -1.4vw;
              //     left: -1.7vw;
              //     background-image: url("../../assets/img/layer3/icon-hover.png");
              //     background-size: 100% 100%;

              //   }
            }
            .img-bg {
              content: "";
              position: absolute;
              width: 203px;
              height: 212px;
              top: -1.4vw;
              left: -1.7vw;
              background-image: url("../../assets/img/layer3/icon-hover.png");
              background-size: 100% 100%;
            }
            .active-icon-bg::after {
              content: "";
              position: absolute;
              width: 203px;
              height: 212px;
              top: -1.4vw;
              left: -1.7vw;
              background-image: url("../../assets/img/layer3/icon-hover.png");
              background-size: 100% 100%;
            }

            .icon-s:nth-child(2),
            .icon-s:nth-child(4) {
              margin-top: 3vw;
            }
          }
        }

        .bottom-icon {
          width: 61vw;
          height: 103px;
          position: absolute;
          bottom: 3%;
          left: 22vw;
          display: flex;
          justify-content: space-between;
          align-items: end;
          cursor: pointer;

          .bottom-num {
            display: block;

            position: relative;

            .activeicon {
              // width: 219px;
              width: 208px;
              height: auto;
              display: block;
            }

            .icon {
              width: 179px;
              height: auto;
              display: block;
            }
          }
        }

        .model-role-bg {
          width: 100%;
          height: 50vw;

          .role {
            z-index: 1;
            position: absolute;
            bottom: 0;
            height: calc(92% - 61px);
            display: block;
            right: 11vw;
          }
          .role-icon {
            z-index: 1;
            position: absolute;
            bottom: 4vw;
            height:498px;
            width: auto;
            display: block;
            right: 4vw;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer3.vue